// removed by extract-text-webpack-plugin
module.exports = {"ali-poster-payment-modal":"ali-poster-payment-modal","modal-float-body":"modal-float-body","classtop-modal-content":"classtop-modal-content","ali-poster-payment-modal-content":"ali-poster-payment-modal-content","btn":"btn","ali-poster-success-modal-content":"ali-poster-success-modal-content","header":"header","close-button":"close-button","ali-pay-title":"ali-pay-title"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/aliPosterPayment/Modal.scss
// module id = KI3W
// module chunks = 0